'use strict';

// Data that can be passed into your application.
let userData = {
	'username': 'TeacherMonthly1',
	'type': 'admin',
	'analyticsUrl': '#'
};

let initializeBootstrap, formFunctions, navigationFunction;

initializeBootstrap = require('./common/initializeBootstrap');
initializeBootstrap.init();

formFunctions = require('./common/_form-functions');
navigationFunction = require('./common/navigation/_index');

formFunctions.init();
navigationFunction.init(userData);

